import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

let nabBtn = document.getElementById("js-navBtn");
let nav = document.getElementById("js-nav");

function toggleAccordion(textBox) {
  if (textBox.style.height === "0px" || textBox.style.height === "") {
    // 開く
    gsap.to(textBox, {
      height: "auto",
      marginTop: 25,
      duration: 0.5,
      opacity: 1,
      ease: "power2.inOut",
    });
  } else {
    // 閉じる
    gsap.to(textBox, {
      height: 0,
      duration: 0.5,
      marginTop: 0,
      opacity: 0,
      ease: "power2.inOut",
    });
  }
}

nabBtn.addEventListener("click", () => {
  nabBtn.classList.toggle("js-active--navBtn");
});

nabBtn.addEventListener("click", () => {
  if (nav.style.height === "0px" || nav.style.height === "") {
    // 開く
    gsap.to(nav, {
      height: "auto",
      duration: 0.8,
      ease: "power2.inOut",
    });
  } else {
    // 閉じる
    gsap.to(nav, {
      height: 0,
      duration: 0.8,
      ease: "power2.inOut",
    });
  }
});
